// Shown when a member who is NOT on a closed group's uploaded allow-list tries
// to join. Surfaces the reason in a popup (no welcome / flower animation plays
// for these blocked joins).
export default function ClosedGroupErrorModal({ show, message, onClose, primary }) {
  if (!show) return null;

  const accent = primary || "#0274F7";

  const body =
    message ||
    "This is a private group with restricted access. Your email address isn't on the approved members list, so you can't join at this time.\n\nNeed access? Please contact the group administrator and ask them to add your email address to the approved members list.";

  // Render each blank-line-separated block as its own paragraph for clean
  // spacing instead of relying on raw newlines inside a single <p>.
  const paragraphs = body.split(/\n{2,}/).map((p) => p.trim()).filter(Boolean);

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-slate-900/60 p-4 backdrop-blur-md"
      onClick={onClose}
    >
      <div
        className="w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl ring-1 ring-black/5"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Accent bar in the community theme color */}
        <div className="h-1.5 w-full" style={{ backgroundColor: accent }} />

        <div className="px-10 pb-9 pt-8">
          {/* Lock icon */}
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-rose-50 to-red-100 ring-8 ring-rose-50">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="h-8 w-8 text-red-600"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>

          <h3 className="mt-5 text-center text-2xl font-bold tracking-tight text-slate-900">
            Access Restricted
          </h3>

          <div className="mt-3 space-y-3">
            {paragraphs.map((p, i) => (
              <p
                key={i}
                className="text-center text-[15px] leading-relaxed text-slate-500"
              >
                {p}
              </p>
            ))}
          </div>

          <button
            type="button"
            onClick={onClose}
            style={{ backgroundColor: accent }}
            className="mt-8 w-full rounded-xl py-3.5 text-sm font-semibold text-white shadow-lg shadow-black/10 transition hover:brightness-95 active:scale-[0.99]"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
